import type { TOrganizationJobsListParams } from 'app/queries/jobs/jobsKeys';

export const buildOrganizationJobsRequest = (organizationId: string, params: TOrganizationJobsListParams) => ({
  oid: organizationId,
  statuses: params.statuses,
  pageNo: params.page.toString(),
  pageSize: params.pageSize.toString(),
  orderBy: params.orderBy,
  orderType: params.orderType,
  search: params.search,
  jobsFrom: params.jobsFrom,
  jobsTo: params.jobsTo,
});
